import { Box, Dialog, ModalProps, useMediaQuery, useTheme } from '@mui/material'
import { PartnerPageData, Workflow } from 'types/types'
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined'
import DynamicForm from './DynamicForm'

type FormModalProps = {
  formProps: {
    workflow: Workflow
    gate: string
    onFormSubmit?: () => void
    gameId: number
  }
  page: PartnerPageData
} & Omit<ModalProps, 'children'>

function FormModal({ formProps, page, ...props }: FormModalProps) {
  const theme = useTheme()

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Dialog
      open={true}
      onClose={props.onClose}
      PaperProps={{
        sx: {
          display: 'flex',
          flexDirection: 'column',
          mt: isMobile ? '10%' : 'none',
          justifyContent: isMobile ? 'flex-start' : 'center',
          alignItems: 'center',
          overflow: 'visible',
          position: 'relative',
        },
      }}
    >
      <Box
        sx={{
          width: '30px',
          height: '30px',
          background: 'linear-gradient(180deg, #FFE600 0%, #D8AF1E 100%)',
          borderRadius: '50%',
          position: 'absolute',
          top: '-15px',
          left: 'calc(50% - 15px)',
          zIndex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <TimerOutlinedIcon sx={{ color: 'rgba(53, 53, 53, 1)' }} fontSize="small" />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: isMobile ? '95vw' : '600px',
          maxHeight: '90vh', // Limit the height of the container
          overflow: 'auto', // Make the container scrollable
        }}
      >
        <Box
          sx={{
            p: 3,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(245, 245, 245, 1)',
            borderRadius: '8px',
            flexDirection: 'column',
          }}
        >
          <DynamicForm
            page={page}
            workflow={formProps.workflow}
            gate={formProps.gate}
            onFormSubmit={formProps.onFormSubmit}
            gameId={formProps.gameId}
          />
        </Box>
      </Box>
    </Dialog>
  )
}

export default FormModal
